// extracted by mini-css-extract-plugin
export default {"infoCardWrapper":"infoCardWrapper--f1TBq","divider":"divider--tjsvZ","hist":"hist--Zzj0R"};